import React, { FunctionComponent, SVGProps } from "react";
import { twMerge } from "tailwind-merge";

import { ReactComponent as ArrowDown } from "assets/icons/arrow-down.svg";
import { ReactComponent as ArrowLeft } from "assets/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { ReactComponent as Checkmark } from "assets/icons/checkmark.svg";

// actions
import { ReactComponent as Loader } from "assets/icons/loading-spinner.svg";
import { ReactComponent as AddComment } from "assets/icons/add-comment.svg";
import { ReactComponent as Airplane } from "assets/icons/airplane.svg";
import { ReactComponent as Archive } from "assets/icons/archive.svg";
import { ReactComponent as BorderPiece } from "assets/icons/border-piece.svg";
import { ReactComponent as BorderRadius } from "assets/icons/border-radius.svg";
import { ReactComponent as Broom } from "assets/icons/broom.svg";
import { ReactComponent as Cancel } from "assets/icons/cancel.svg";
import { ReactComponent as CheckCircle } from "assets/icons/check-circle.svg";
import { ReactComponent as DoubleChevron } from "assets/icons/double-chevron.svg";
import { ReactComponent as ChevronDown } from "assets/icons/chevron-down.svg";
import { ReactComponent as ChevronLeft } from "assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRight } from "assets/icons/chevron-right.svg";
import { ReactComponent as ChevronUp } from "assets/icons/chevron-up.svg";
import { ReactComponent as Close } from "assets/icons/close.svg";
import { ReactComponent as Clone } from "assets/icons/clone.svg";
import { ReactComponent as College } from "assets/icons/college.svg";
import { ReactComponent as Comment } from "assets/icons/comment.svg";
import { ReactComponent as Compare } from "assets/icons/compare.svg";
import { ReactComponent as ContentCopy } from "assets/icons/content-copy.svg";
import { ReactComponent as Creatives } from "assets/icons/creatives.svg";
import { ReactComponent as Desktop } from "assets/icons/desktop.svg";
import { ReactComponent as Document } from "assets/icons/document.svg";
import { ReactComponent as Edit } from "assets/icons/edit.svg";
import { ReactComponent as Filter } from "assets/icons/filter.svg";
import { ReactComponent as WidthFixed } from "assets/icons/width-fixed.svg";
import { ReactComponent as Flag } from "assets/icons/flag.svg";
import { ReactComponent as Forward } from "assets/icons/forward.svg";
import { ReactComponent as WidthFill } from "assets/icons/width-fill.svg";
import { ReactComponent as Trash } from "assets/icons/trash.svg";
import { ReactComponent as Ellipsis } from "assets/icons/ellipsis.svg";
import { ReactComponent as EyeHidden } from "assets/icons/eye-hidden.svg";
import { ReactComponent as EyeVisible } from "assets/icons/eye-visible.svg";
import { ReactComponent as Gear } from "assets/icons/gear.svg";
import { ReactComponent as Hamburger } from "assets/icons/hamburger.svg";
import { ReactComponent as HugContent } from "assets/icons/width-hug.svg";
import { ReactComponent as Info } from "assets/icons/info.svg";
import { ReactComponent as InsertImage } from "assets/icons/insert-image.svg";
import { ReactComponent as LinkIndicator } from "assets/icons/link-indicator.svg";
import { ReactComponent as Minus } from "assets/icons/minus.svg";
import { ReactComponent as Mobile } from "assets/icons/mobile.svg";
import { ReactComponent as Logout } from "assets/icons/logout.svg";
import { ReactComponent as Move } from "assets/icons/move.svg";
import { ReactComponent as SwapHorizontal } from "assets/icons/swap-horizontal.svg";
import { ReactComponent as MoreVertical } from "assets/icons/more-vertical.svg";
import { ReactComponent as NewDocument } from "assets/icons/document-new.svg";
import { ReactComponent as Padding } from "assets/icons/padding.svg";
import { ReactComponent as PaddingLeft } from "assets/icons/padding-left.svg";
import { ReactComponent as PaddingVertical } from "assets/icons/padding-vertical.svg";
import { ReactComponent as Parent } from "assets/icons/parent.svg";
import { ReactComponent as Plus } from "assets/icons/plus.svg";
import { ReactComponent as PopoverArrow } from "assets/icons/popover-arrow.svg";
import { ReactComponent as QuickTipClose } from "assets/icons/quick-tip-close.svg";
import { ReactComponent as Refresh } from "assets/icons/refresh.svg";
import { ReactComponent as Reply } from "assets/icons/reply.svg";
import { ReactComponent as Replay } from "assets/icons/replay.svg";
import { ReactComponent as RoundPlus } from "assets/icons/round-plus.svg";
import { ReactComponent as Search } from "assets/icons/search.svg";
import { ReactComponent as UserAvatar } from "assets/icons/user-avatar.svg";
import { ReactComponent as Sidebar } from "assets/icons/sidebar.svg";
import { ReactComponent as Spinner } from "assets/icons/spinner.svg";
import { ReactComponent as Stack } from "assets/icons/stack.svg";
import { ReactComponent as TextAlignCenter } from "assets/icons/text-align-center.svg";
import { ReactComponent as TextAlignJustified } from "assets/icons/text-align-justified.svg";
import { ReactComponent as TextAlignLeft } from "assets/icons/text-align-left.svg";
import { ReactComponent as Topbar } from "assets/icons/topbar.svg";
import { ReactComponent as Upload } from "assets/icons/upload.svg";
import { ReactComponent as Undo } from "assets/icons/undo.svg";
import { ReactComponent as More } from "assets/icons/more.svg";
import { ReactComponent as ButtonAlignLeft } from "assets/icons/button-align-left.svg";
import { ReactComponent as ButtonAlignCenter } from "assets/icons/button-align-center.svg";
import { ReactComponent as ButtonAlignRight } from "assets/icons/button-align-right.svg";
import { ReactComponent as DragDrop } from "assets/icons/drag-drop.svg";
import { ReactComponent as DragHandle } from "assets/icons/drag-handle.svg";
import { ReactComponent as MondayBoard } from "assets/icons/monday-board.svg";
import { ReactComponent as CampaignWriter } from "assets/icons/campaign-writer.svg";
import { ReactComponent as Event } from "assets/icons/event.svg";
import { ReactComponent as Email } from "assets/icons/email.svg";
import { ReactComponent as LandingPage } from "assets/icons/landing-page.svg";
import { ReactComponent as Layers } from "assets/icons/layers.svg";
import { ReactComponent as Theme } from "assets/icons/theme.svg";
import { ReactComponent as Folder } from "assets/icons/folder.svg";
import { ReactComponent as Settings } from "assets/icons/settings.svg";
import { ReactComponent as Other } from "assets/icons/other.svg";
import { ReactComponent as Summary } from "assets/icons/summary.svg";
import { ReactComponent as Expand } from "assets/icons/expand.svg";
import { ReactComponent as HistoryEdu } from "assets/icons/history-edu.svg";
import { ReactComponent as ThumbsUp } from "assets/icons/thumbs-up.svg";
import { ReactComponent as ThumbsDown } from "assets/icons/thumbs-down.svg";

// sidebar nav
import { ReactComponent as SidebarNavRecentCreatives } from "assets/icons/sidebar-nav/recent-creatives.svg";
import { ReactComponent as SidebarNavCampaigns } from "assets/icons/sidebar-nav/campaigns.svg";
import { ReactComponent as SidebarNavApprovalQueue } from "assets/icons/sidebar-nav/approval-queue.svg";
import { ReactComponent as SidebarNavApproved } from "assets/icons/sidebar-nav/approved.svg";
import { ReactComponent as SidebarNavTheme } from "assets/icons/sidebar-nav/theme.svg";
import { ReactComponent as SidebarNavTemplates } from "assets/icons/sidebar-nav/templates.svg";
import { ReactComponent as SidebarNavProfile } from "assets/icons/sidebar-nav/profile.svg";
import { ReactComponent as SidebarNavStrategy } from "assets/icons/sidebar-nav/strategy.svg";
import { ReactComponent as SidebarNavPartnership } from "assets/icons/sidebar-nav/partnership.svg";
import { ReactComponent as SidebarNavPrograms } from "assets/icons/sidebar-nav/program-brief.svg";
import { ReactComponent as SidebarNavA2A } from "assets/icons/sidebar-nav/a2a.svg";
import { ReactComponent as SidebarNavA2E } from "assets/icons/sidebar-nav/a2e.svg";
import { ReactComponent as SidebarNavBrandGuidelines } from "assets/icons/sidebar-nav/guidelines.svg";
import { ReactComponent as SidebarNavClient } from "assets/icons/sidebar-nav/client.svg";
import { ReactComponent as SidebarNavAdminWorkspace } from "assets/icons/sidebar-nav/admin-workspace.svg";
import { ReactComponent as SidebarNavCampaignTemplates } from "assets/icons/sidebar-nav/campaign-templates.svg";
import { ReactComponent as SidebarNavStudentRouter } from "assets/icons/sidebar-nav/student-router.svg";

// indicators
import { ReactComponent as InfoIndicator } from "assets/icons/indicator-info.svg";
import { ReactComponent as RequiredIndicator } from "assets/icons/required-indicator.svg";
import { ReactComponent as SuccessIndicator } from "assets/icons/indicator-success.svg";
import { ReactComponent as WarningIndicator } from "assets/icons/indicator-warning.svg";
import { ReactComponent as ExclamationCircle } from "assets/icons/exclamation-circle.svg";
import { ReactComponent as LockClosed } from "assets/icons/lock-closed.svg";
import { ReactComponent as AI } from "assets/icons/ai.svg";

// images
import { ReactComponent as ApolloLogo } from "assets/images/apollo-logo.svg";
import { ReactComponent as ApolloIcon } from "assets/images/apollo-icon.svg";
import { ReactComponent as TwoOceanLogo } from "assets/images/two-ocean-logo.svg";
import { ReactComponent as ChooseColor } from "assets/images/choose-color.svg";

export const icons = {
  AI,
  Loader,
  AddComment,
  Airplane,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BorderPiece,
  BorderRadius,
  Broom,
  Cancel,
  DoubleChevron,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CheckCircle,
  Checkmark,
  ChooseColor,
  Close,
  Clone,
  College,
  Comment,
  Compare,
  ContentCopy,
  Creatives,
  Desktop,
  Document,
  Edit,
  Filter,
  Forward,
  WidthFixed,
  Flag,
  WidthFill,
  Trash,
  Ellipsis,
  ExclamationCircle,
  EyeHidden,
  EyeVisible,
  Gear,
  Hamburger,
  HistoryEdu,
  HugContent,
  Info,
  InfoIndicator,
  InsertImage,
  LinkIndicator,
  LockClosed,
  Logout,
  Minus,
  Mobile,
  Move,
  SwapHorizontal,
  MoreVertical,
  NewDocument,
  Other,
  Padding,
  PaddingLeft,
  PaddingVertical,
  Parent,
  Plus,
  PopoverArrow,
  QuickTipClose,
  Refresh,
  Reply,
  Replay,
  RequiredIndicator,
  RoundPlus,
  Search,
  Sidebar,
  Spinner,
  SuccessIndicator,
  Summary,
  Expand,
  Layers,
  Stack,
  TextAlignCenter,
  TextAlignJustified,
  TextAlignLeft,
  Theme,
  ThumbsDown,
  ThumbsUp,
  Topbar,
  Undo,
  UserAvatar,
  More,
  ButtonAlignLeft,
  ButtonAlignCenter,
  ButtonAlignRight,
  DragDrop,
  DragHandle,
  Upload,
  WarningIndicator,
  MondayBoard,
  CampaignWriter,
  Event,
  Email,
  LandingPage,
  Folder,
  SidebarNavRecentCreatives,
  SidebarNavCampaigns,
  SidebarNavApprovalQueue,
  SidebarNavApproved,
  SidebarNavTheme,
  SidebarNavTemplates,
  SidebarNavProfile,
  SidebarNavStrategy,
  SidebarNavPartnership,
  SidebarNavPrograms,
  SidebarNavA2A,
  SidebarNavA2E,
  SidebarNavBrandGuidelines,
  SidebarNavClient,
  SidebarNavAdminWorkspace,
  SidebarNavCampaignTemplates,
  SidebarNavStudentRouter,
  Settings,
};

export const images = {
  ApolloLogo,
  ApolloIcon,
  TwoOceanLogo,
};

export type IconName = keyof typeof icons | keyof typeof images;

export interface SVGIconProps extends Omit<SVGProps<SVGSVGElement>, "ref"> {
  customClass?: string;
  className?: string;
  /**
   * @deprecated Icons should not have a title attribute. Put it on the parent.*/
  title?: string;
  /**
   * @deprecated Icons can't make use of the alt attribute. */
  alt?: string;
  /**
   * @deprecated Icons should not have an onClick attribute. Put the icon inside a button.  */
  onClick?: () => void;
}

export type IconComponent = FunctionComponent<SVGIconProps>;

const createIconComponent = (Icon: FunctionComponent<SVGProps<SVGSVGElement>>): IconComponent => {
  return ({ customClass, className, onClick, ...rest }: SVGIconProps): React.JSX.Element => (
    <Icon className={twMerge(customClass, className)} onClick={onClick} {...rest} />
  );
};

const Icons = Object.fromEntries(
  [...Object.entries(icons), ...Object.entries(images)].map(([key, value]) => [
    key,
    createIconComponent(value as FunctionComponent<SVGProps<SVGSVGElement>>),
  ]),
) as { [K in IconName]: IconComponent };

export default Icons;
